module.exports = __webpack_public_path__ + "static/img/mbg.b10234a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/jiameng/mbg.jpg
// module id = AJ+m
// module chunks = 0